// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_22ceb1', '__Roboto_Fallback_22ceb1'","fontStyle":"normal"},"className":"__className_22ceb1","variable":"__variable_22ceb1"};